import jSmoothScroll from './lib/j_smoothScroll_es';
import jModal from './lib/j_modal_es';
import $ from './lib/jquery-3.1.1.min';

const Init = () => {
    
    $(function () {
        var headerHeight = $("#header").height();
        const J_SCROLL = new jSmoothScroll(
            "a",
            {
                easing: "easeOutQuint",
                customAnchor: "?anchor=",
                blank: true,
                posFix: headerHeight
            }
        );

        var J_MODAL_PRODUCT;
        var J_MODAL;

        if (document.getElementsByClassName("j-modal").length > 0) {
            
            J_MODAL = new jModal(
                ".j-modal", 
                {
                    width: 1040,
                    modalSpeed: 400,
                    bgOpacity: 0.4,
                    innerBgPadding: 0,
                    closeCancel: false
                }
            );
        };

        if (document.getElementsByClassName("j-modal_product").length > 0) {
            J_MODAL_PRODUCT = new jModal(
                ".j-modal_product",
                {
                    width: 1040,
                    modalSpeed: 400,
                    bgOpacity: 0.4,
                    innerBgPadding: 0,
                    closeCancel: false
                }
            );
            J_MODAL_PRODUCT.OpenEnd = function () {
                $(".j-modal_close").on("click", function (ev) {
                    ev.preventDefault();
                    J_MODAL_PRODUCT.Close();
                });
            };
            J_MODAL_PRODUCT.CloseEnd = function () {
                $(".j-modal_close").off();
            };
        }
        var myURL = location.pathname;
        

        var nmb = myURL.split("/").length - 1;
        if (nmb == 2) {
            
            for (let i = 0; i < $("#header nav li").length; i++) {
                var tmpURL = $("#header nav li").eq(i).find("a").attr("href");
                
                tmpURL = tmpURL.replace("/danone/?anchor=", "#");
                $("#header nav li").eq(i).find("a").attr("href", tmpURL);
                
            }
        }
        else {
            var navLength = $("#header nav ul li").length;
            myURL = myURL.replace("index.html", "");
            for (var i = 0; i < navLength; i++) {
                var tmpURL = $("#header nav ul li").eq(i).find("a").attr("href");
                if (myURL.match(tmpURL) && tmpURL.length > 0) {
                    $("#header nav ul li").eq(i).find("a").addClass("current");
                }
            }
        }

        $(window).on("scroll load resize", function () {
            headerHeight = $("#header").height();
            var footerHeight = $("#footer").height();
            var docHeight = $(document).height() - $(window).height() - footerHeight;

            if ($(window).scrollTop() > 0) {
                if (! $(".m-pagetop").hasClass("active")) {
                     $(".m-pagetop").addClass("active");
                }
            }
            else {
                if ( $(".m-pagetop").hasClass("active")) {
                     $(".m-pagetop").removeClass("active");
                }
            }

            
            if ($(window).scrollTop() > docHeight) {
                $(".m-pagetop").css("bottom", ($(window).scrollTop() - docHeight + 10) +"px"); 
            }
            else {
                $(".m-pagetop").css("bottom", "10px"); 
            }

            if ($(window).scrollTop() > headerHeight) {
                if (!$("#header").hasClass("fixed")) {
                    $("#header").addClass("fixed");
                }
            }
            else {
                if ($("#header").hasClass("fixed")) {
                    $("#header").removeClass("fixed");
                }
            }
        });

        var element = document.getElementById('anc');
        if(element.classList.contains('home') == true) {

            $(window).on("scroll load", function () {
                var pos = $("#about_top").offset().top - $(window).height() / 2 + $("#header").height();
                
                if ($(window).scrollTop() > pos) {
                    if (!$("#about_top .p-about_main").hasClass("play")) {
                        $("#about_top .p-about_main").addClass("play");
                    }
                }
                
            });

            $(window).on("load", function () {
                    $(".p-kv_look").addClass("play"); 
            });
        }

        $("#j-navbtn").on("click", function () {
            var hdr = $("#header");
            if (!hdr.hasClass("active")) {
                hdr.addClass("active");
            }
            else {
                hdr.removeClass("active");
            }
        });

        $("#j-gnav_close").on("click", function (ev) {
            ev.preventDefault();
            $("#header").removeClass("active");
        });

        $("#header nav a").on("click", function () {
            if ($("#header").hasClass("active")) {
                $("#header").removeClass("active")
            }
        });
    });


} 

export default Init;
